import React, {useEffect} from 'react';
import {TestItems} from "./test-items/Test-items";
import {useAppDispatch, useAppSelector} from "common/hook";
import {useParams} from "react-router-dom";
import {getLessonsTest} from "features/model/service/lessons/lessons-test/get-lessons-test/getLessonsTest";
import {Preloader} from "components/layout/preloader/Preloader";
import {NothingYetMessage} from "components/pages/personal-cabinet/nothing-yet-message/NothingYetMessage";
import {CustomPagination} from "components/pagination/CustomPagination";
import {ReactComponent as PlustIcon} from '../../../../../../assets/main/groups/online/plus.svg';
import {ROLE_DEMO_STUDENT, ROLE_STUDENT, ROLE_TEACHER} from "entities/constants/constants";
import {setFormAddTestAC} from "app/popups-reducer";
import {
    getLessonsTestsAllowed
} from "features/model/service/lessons/lessons-test/get-lessons-tests-allowed/getLessonsTestsAllowed";

export const Tests = () => {
    const dispatch = useAppDispatch()
    const roleType = useAppSelector((state) => state.role.roleType);
    const {lessonsId} = useParams()
    const lessonsTestData = useAppSelector(state => state.lessonsTest)
    const {isLoading, items, pagination, error} = lessonsTestData;
    const {pageSize, pageCount, page} = pagination
    const isFormAddTest = useAppSelector((state) => state.popups.isFormAddTest);


    const onClickHandler = () => {
        dispatch(setFormAddTestAC(!isFormAddTest))
        dispatch(getLessonsTestsAllowed(lessonsId))
    }


    useEffect(() => {
        dispatch(getLessonsTest({lessonsId}))
    }, [dispatch, lessonsId]);


    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(getLessonsTest({page: value - 1}));
    };

    return (
        <div className="data-tbl tests-tbl has-delete">

            {roleType === ROLE_TEACHER &&(
                <div className="row thead">
                    <div className="col test-col auto-width">Тест</div>
                    <div className="col group-col">Автор</div>
                    <div className="col students-col">Студенты</div>
                    <div className="col passed-test-col align-right">Прошли тест</div>
                    <div className="col delete-col"></div>
                </div>
            )}
            {roleType !== ROLE_TEACHER && (
                <div className="row thead">
                    <div className="col group-name-col full-width-mobile">Тест</div>
                    <div className="col group-col full-width-mobile">Автор</div>
                </div>
            )}


            {isLoading ? (
                <Preloader/>
            ) : items && items.length > 0 ? (
                items?.map((item) => (
                    <TestItems key={item.id} item={item}/>
                ))
            ) : (
                <NothingYetMessage/>
            )}

            {pageCount > 1 && (
                <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle}/>
            )}


            {roleType === ROLE_TEACHER &&
                <div className="add-test add-action-btn" onClick={onClickHandler}>
                    <PlustIcon/>
                    Добавить тест
                </div>
            }

        </div>
    );
};

